import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

const Login = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();
  return (
    <div style={{ paddingRight: '5vw' }}>
      <ButtonWithIcon
        label={t('LogIn')}
        icon="bi bi-box-arrow-right"
        onClick={() => { instance.loginRedirect(); }}
        backgroundColor='white'
        testId="login"
        color='var(--primary-color)' />
    </div>
  )
}
export default Login;